const FNV_OFFSET_BASIS = 0x811c9dc5
const FNV_PRIME = 0x01000193

/**
 * 32-bit FNV-1a as 8 lowercase hex characters. It hashes UTF-16 code units, so non-ASCII input
 * differs from byte-oriented implementations; every tab uses this one, which is all that matters.
 */
export const fnv1a = (input: string): string =>
  input
    .split('')
    .reduce((hash, char) => Math.imul(hash ^ char.charCodeAt(0), FNV_PRIME) >>> 0, FNV_OFFSET_BASIS)
    .toString(16)
    .padStart(8, '0')
